import React, { useEffect, useState } from "react";
import "./dashboard.css";
import toppic from "../assets/sf-removebg-preview.png";
import bottompic from "../assets/logo-1.png";
import efeslogo from "../assets/anadolu-efes-logo.png";

const Dashboard = () => {
  const userLang = navigator.language;
  const [language, setLanguage] = useState(userLang);
  const [headerText, setHeaderText] = useState("");
  const [topText, setTopText] = useState("");
  const [bottomText, setBottomText] = useState("");
  const handleLanguageTr = () => {
    setLanguage("tr-TR");
  };
  const handleLanguageEn = () => {
    setLanguage("en-US");
  };

  useEffect(() => {
    language === "tr-TR"
      ? setHeaderText("Dijital İK Çözümlerine Erişim")
      : setHeaderText("Digital HR Solutions");
    language === "tr-TR"
      ? setTopText(
          "İK Uygulamaları Şifre Oluşturmak/ Resetlemek İçin\n" +
            "              Tıklayınız (Mavi Yaka)"
        )
      : setTopText(
          "Click to Create/Reset Password for Digital HR Solutions (Blue Collar)"
        );

    language === "tr-TR"
      ? setBottomText("Dijital İK Çözümleri Tıklayınız ")
      : setBottomText("Click to Access for Digital HR Solutions");
  }, [language]);

  return (
    <div style={{ background: "#104585" }}>
      <div className="navbar">
        <div className="container">
          <img className="logo" src={efeslogo} alt="efes-logo"></img>
          <div className="text">
            <div className="headertext">{headerText}</div>
          </div>
          <div className="row">
            <button
              className="btn col"
              style={{
                border: language === "tr-TR" ? "1px solid #3498db" : "",
              }}
              onClick={handleLanguageTr}
            >
              TR
            </button>
            <button
              className="btn col"
              style={{
                border: language !== "tr-TR" ? "1px solid #3498db" : "",
              }}
              onClick={handleLanguageEn}
            >
              EN
            </button>
          </div>
        </div>
      </div>

      <div className="container bottom">
        <div className="row">
          <div className="card">
            <div className="row">
              <div className="col-4">
                <img src={bottompic} alt="yapboz2" />
              </div>
              <div className="col-5">
                <a
                  href="https://efes-sfpassreset.cfapps.eu10-005.hana.ondemand.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {topText}
                </a>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="card">
              <div className="row">
                <div className="col-4">
                  <img className="yap-boz1" src={toppic} alt="yapboz1" />
                </div>
                <div className="col-5">
                  <a
                    href="https://performancemanager.successfactors.eu/login?_s.crb=y7EdaiGOTcSKfzmfUhF44ODMXDMEwV0gpWo1vk8WpWg%253d#/companyEntry"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {bottomText}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
